import { SchemeTypes } from 'config';
import _ from 'lodash';
// import { useSelector } from 'react-redux';
import OssSchemeTypes from '../../../config/schemeType';
import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';

interface ITradingName {
  applicant_trading_name_id: number;
  registration_id: number;
  trading_name: string;
}
interface IIdentificationDetails {
  applicant_id: number;
  registration_id: number;
  username: string;
  user_id: number;
  agent_id: number | null;
  company_name: string;
  intermidiary: number;
  agent_vat_num: string;
  vat_num: string;
  vat_group: string;
  non_national_tax_ref_num: string;
  non_place_of_business: number;
  non_issuing_country: number;
  import_national_tax_ref_num: string;
  import_place_of_business: number;
  import_issuing_country: number;
  trading_name: Array<ITradingName>;
  is_agent: boolean;
  status: number;
  state: string;
  scheme: OssSchemeTypes;
  country_of_business_id: number | null;
}

interface IWebsite {
  applicant_website_id: number;
  registration_id: number;
  website_url: string;
}

interface IContactDetails {
  name: string;
  first_name: string;
  last_name: string;
  street: string;
  building_identifier: string;
  post_code: string;
  city: string;
  country_id: number;
  telephone: string;
  email: string;
  website_url: Array<IWebsite>;
}

interface IPaymentDetails {
  iban: string;
  oban: string;
  iban_oban_selection: string;
  account_holder: string;
  bic: string;
}

interface IFirstSupplyDetails {
  first_supply_date: Date;
  registration_date: Date;
}

interface IFixedEstablishments {
  issuing: number;
  vat_id_num: string;
  name: string;
  fixed_establish_address_id: number;
  fixed_establish_id: number;
  country_id: number;
  address_free: string;
  street: string;
  building_identifier: string;
  suite_identifier: string;
  floor_identifier: string;
  district_name: string;
  pob: string;
  post_code: string;
  city: string;
  country_sub_entity: string;
  other_local_id: number;
  start_date: Date;
}

interface IPreviousUseOfSpecialSchemes {
  country_id: number;
  vat_id_num: string;
  id_type_id: string;
}

interface IChangeIdentification {
  vat_id_num: string;
  country_id: number;
  applicant_type_id: string;
}

interface IIdentificationInOtherEuCountries {
  country_id: number;
  vat_id_num: string;
  id_type_id: number;
}

interface IAdministration {
  registration_comments: string;
  registration_date: Date;
  commencement_date: Date;
  change_date: Date;
  modified_at: string;
  created_at: string;
  status: string;
  status_id: number;
  state: string;
  changed_at: string;
  transmitted: string;
}

interface ICountriessData {
  country_id: string;
  code: string;
  description: string;
  numeric_code: number;
}

interface IExclusionDetail {
  cessation_date: Date;
  exclusion_comments: string;
  exclusion_date: Date;
  exclusion_decision_date: Date;
  exclusion_detail_id: number;
  exclusion_request_date: Date;
  exclusion_status: number;
  exclusion_type_id: number;
  msid_member_state_id: number;
  msid_vat_num_id: string;
  non_compliant_payment: number;
  non_compliant_return: number;
  registration_id: number;
}

interface IRegistrationDetail {
  identification_details: IIdentificationDetails;
  administration: Array<IAdministration>;
  change_identification: Array<IChangeIdentification>;
  contact_details: IContactDetails;
  first_supply_details: Array<IFirstSupplyDetails>;
  // fixed_establish_details: Array<IFixedEstablishments>;
  // identification_in_other_countries: Array<IIdentificationInOtherEuCountries>;
  payment_details: Array<IPaymentDetails>;
  // previous_use_of_special_schemes: Array<IPreviousUseOfSpecialSchemes>;
  exclusionDetail: IExclusionDetail;
}

// export const useGetRegistrationDetailStatus = (): StateStatus => {
//   const data = useSelector((state: any) =>
//     _.get(
//       state[ReducerKeys.REGISTRATION_DETAIL_REDUCER].registrationDetail,
//       'status',
//       StateStatus.Pending
//     )
//   );
//   return data;
// };

interface IRegistrationDetailOutput {
  data: IRegistrationDetail;
  status: StateStatus;
}

export const useGetRegistrationDetails = (): IRegistrationDetailOutput => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REGISTRATION_DETAIL_REDUCER].registrationDetail
  );
  return data;
};

export const useFixedEstablishmentsDetails =
  (): Array<IFixedEstablishments> => {
    const data = useShallowEqualSelector((state: any) =>
      _.get(
        state[ReducerKeys.REGISTRATION_DETAIL_REDUCER],
        'fixedEstablishments',
        null
      )
    );
    return data;
  };

export const useGetPreviousUseOfSpecialSchemes =
  (): Array<IPreviousUseOfSpecialSchemes> => {
    const data = useShallowEqualSelector((state: any) =>
      _.get(
        state[ReducerKeys.REGISTRATION_DETAIL_REDUCER],
        'previousUseOfSpecialSchemes',
        null
      )
    );
    return data;
  };

export const useGetIdentificationInOtherEuCountries =
  (): Array<IIdentificationInOtherEuCountries> => {
    const data = useShallowEqualSelector((state: any) =>
      _.get(
        state[ReducerKeys.REGISTRATION_DETAIL_REDUCER],
        'identificationInOtherEuCountries',
        null
      )
    );
    return data;
  };

export const useGetChangeIdentification = (): Array<IChangeIdentification> => {
  const data = useShallowEqualSelector((state: any) =>
    _.get(
      state[ReducerKeys.REGISTRATION_DETAIL_REDUCER].registrationDetail.data,
      'change_identification',
      null
    )
  );
  return data;
};

export const useGetAdministration = (): IAdministration => {
  const data = useShallowEqualSelector((state: any) =>
    _.get(
      state[ReducerKeys.REGISTRATION_DETAIL_REDUCER].registrationDetail.data,
      'administration',
      null
    )
  );
  return data;
};

// COUNTRIES
export const useGetCountriesNonMemberState = (): Array<ICountriessData> => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REGISTRATION_DETAIL_REDUCER].nonMemberStateCountries
        .data
  );
  return data;
};

// IMPORT
export const useGetImportCountries = (): Array<ICountriessData> => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REGISTRATION_DETAIL_REDUCER].importCountries.data
  );
  return data;
};

export const useGetCountriesMemberState = (): Array<ICountriessData> => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REGISTRATION_DETAIL_REDUCER].memberStateCountries.data
  );
  return data;
};

export const useGetAllCountries = (): Array<ICountriessData> => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REGISTRATION_DETAIL_REDUCER].allCountriesList.data
  );
  return data;
};

export const useGetCountriesExcludeCyprus = (): Array<ICountriessData> => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REGISTRATION_DETAIL_REDUCER].countiesExcludeCyprus.data
  );
  return data;
};

// SCHEME TYPES
interface ISChemeTypesData {
  applicant_type_id: number;
  code: 'EU' | 'NON_EU' | 'IOSS';
  description: string;
}

export const useGetSchemeTypes = (): Array<ISChemeTypesData> => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REGISTRATION_DETAIL_REDUCER].schemeTypesList.data
  );
  return data;
};

interface IIdType {
  id_type_id: number;
  id_type: string;
  code: string;
}
interface IIdTypesOutput {
  status: StateStatus;
  data: Array<IIdType>;
}

export const useGetIdTypes = (): IIdTypesOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.REGISTRATION_DETAIL_REDUCER].idTypeList
  );
  return data;
};

export const useGetApplicantActiveRegistrations = (): {
  active_registrations: Array<any>;
  scheme_type?: SchemeTypes;
  vat_id_num?: string;
} => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REGISTRATION_DETAIL_REDUCER]
        .applicantActiveRegistrations.data
  );
  return (
    data ?? {
      active_registrations: [],
    }
  );
};
